import React from 'react';
import CBDisabledBadge from '../../shared/CBDisabledBadge';

class WorkshopListItem extends React.Component {
  getIconUrl = () => {
    const {
      editMode, isFavourite
    } = this.props;
    if (editMode) {
      return '/img/icon_edit.svg';
    }
    else {
      return isFavourite ? '/img/round_x_icon.svg' : '/img/round_plus_icon.svg';
    }
  }

  render() {
    const {
      label, value, isFavourite, id, buttonAction, isDisabled,
    } = this.props;
    // isDisabled is optional: this component is also used in the favourites and
    // "my workshops" lists, which never pass it.
    const textStyle = isDisabled
      ? Object.assign({}, styles.infoLabel, styles.disabledText)
      : styles.infoLabel;
    const valueStyle = isDisabled
      ? Object.assign({}, styles.infoValue, styles.disabledText)
      : styles.infoValue;

    return (
      <div className={id} style={styles.workshopContainer}>
        <div style={styles.workshopTextContainer}>
          <div style={styles.labelRow}>
            <p className='font-titillium-web-semi-bold' style={textStyle}>
              {label}
            </p>
            {isDisabled && <CBDisabledBadge style={styles.badge} />}
          </div>
          <p className='font-titillium-web-light' style={valueStyle}>
            {value}
          </p>
        </div>
        <div style={styles.workshopControlsContainer}>
          <img
            alt='Icon'
            style={styles.icon}
            onClick={() => buttonAction(id)}
            src={this.getIconUrl()}
          />
        </div>
      </div>
    );
  }
}

const styles = {
  workshopContainer: {
    borderBottom: '1px solid rgba(255, 255, 255, 0.4)',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 16,
  },
  labelRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  badge: {
    marginLeft: 8,
  },
  infoLabel: {
    color: '#FFF',
    fontSize: 14,
    fontWeight: 600,
  },
  infoValue: {
    color: '#FFF',
    fontSize: 14,
    fontWeight: 200,
  },
  disabledText: {
    opacity: 0.5,
  },
  workshopControlsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    cursor: 'pointer',
    width: 30,
    height: 30,
  },
};

export default WorkshopListItem;
